"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const drippingService_1 = __importDefault(require("../services/drippingService"));
const stores_1 = require("../stores");
const useSetClassesForDripping = ({ isBulkOperation }) => {
    const { params: { moduleId } } = (0, react_router_dom_1.useRouteMatch)();
    const getClasses = (0, react_1.useCallback)(async () => {
        let newClasses = [];
        if (isBulkOperation) {
            newClasses = await drippingService_1.default.fetchProductClasses();
        }
        else if (moduleId) {
            newClasses = await drippingService_1.default.fetchModuleClasses(moduleId);
        }
        stores_1.DrippingStore.setClassesForDripping(newClasses);
    }, [moduleId, isBulkOperation]);
    (0, react_1.useEffect)(() => {
        getClasses();
    }, [getClasses]);
    return { refetchClasses: getClasses };
};
exports.default = useSetClassesForDripping;
